<template>
  <el-row>
    <el-card shadow="none"
             class="form-card mb-15">
      <el-form :inline="true"
               :model="searchForm"
               ref="search_form"
               class="search-form">
        <el-form-item label="账号:"
                      prop="username">
          <el-input v-model.trim="searchForm.username"
                    placeholder="账号"></el-input>
        </el-form-item>
        <el-form-item label="姓名:"
                      prop="fullname">
          <el-input v-model.trim="searchForm.fullname"
                    placeholder="姓名"></el-input>
        </el-form-item>
        <el-form-item label="联系方式:"
                      prop="mobile">
          <el-input v-model.trim="searchForm.mobile"
                    placeholder="联系方式"></el-input>
        </el-form-item>
        <el-form-item label="状态:"
                      prop="status">
          <el-select v-model="searchForm.status"
                     placeholder="状态">
            <el-option label="启用"
                       value="1"></el-option>
            <el-option label="禁用"
                       value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     @click="searchSubmit('search_form')">查询
          </el-button>
          <el-button icon="el-icon-refresh"
                     @click="resetForm('search_form')">重置
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-row>
      <el-button v-has="'/user/add'"
                 type="primary"
                 @click="handleAdd">新 增</el-button>
    </el-row>
    <el-card shadow="none"
             class="mt-15">
      <el-table max-height="520"
                ref="settleTable"
                :data="tableData"
                style="width: 100%">
        <el-table-column fixed="left"
                         type="index"
                         label="序号"
                         width="60">
        </el-table-column>
        <el-table-column v-for="(item, index) in tableTitle"
                         :fixed="item.fixed"
                         :key="index"
                         :label="item.name"
                         :prop="item.prop"
                         :min-width="item.width"
                         :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-switch v-if="item.prop === 'switchStaus'"
                       v-model="scope.row.switchStaus"
                       active-color="#13ce66"
                       inactive-color="#ff4949"
                       @change="(params) => handleOnOff(params, scope.row)">
            </el-switch>
            <span v-else
                  slot-scope="scope">{{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="240">
          <template slot-scope="scope">
            <!-- <el-button size="mini"
                       plain
                       type="primary"
                       @click="handleDetail(scope.row)">详情</el-button> -->
            <!-- <el-button size="mini"
                       plain
                       type="primary"
                       @click="handleVerify(scope.row)">重置密码</el-button> -->
            <el-button v-has="'/user/edit'"
                       plain
                       size="mini"
                       type="success"
                       @click="handleRole(scope.row)">分配角色</el-button>
            <el-button v-has="'/user/edit'"
                       size="mini"
                       type="primary"
                       @click="handleEdit(scope.row)">编辑</el-button>
            <el-button v-has="'/user/del'"
                       size="mini"
                       type="danger"
                       @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <Pagination :total="pagination.total"
                  :current="pagination.currentPage"
                  :pageSize="pagination.perPage"
                  @handleSizeChange="handleSizeChange"
                  @handleCurrent="handleCurrentChange"></Pagination>
    </el-card>
    <add-user v-if="showUserModal"
              :isShow="showUserModal"
              :data="userData"
              @handleClose="closeUserModal"></add-user>
    <assign-role v-if="showRoleModal"
                 :isShow="showRoleModal"
                 :data="roleData"
                 @handleClose="closeRoleModal"></assign-role>
    <Details v-if="showDetailModal"
             :isShow="showDetailModal"
             :data="detailData"
             @handleClose="closeDetailModal"></Details>
    <el-dialog title="重置密码"
               :visible.sync="resetPassModal"
               width="40%">
      <el-col :span="24">
        <el-form :model="resetPassForm"
                 :rules="resetRules"
                 ref="resetPassForm"
                 label-width="110px"
                 class="reset-form">
          <el-form-item label="新密码:"
                        prop="password">
            <el-input type="password"
                      v-model="resetPassForm.password"
                      placeholder="请输入新密码"></el-input>
            <p class="tips">密码由6~20位字母、数字 、 _ 、@ 组成，不能设置特殊字符</p>
          </el-form-item>
          <el-form-item label="确认密码:"
                        prop="checkPass">
            <el-input type="password"
                      v-model="resetPassForm.checkPass"
                      placeholder="请再次确认密码"></el-input>
          </el-form-item>
        </el-form>
      </el-col>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="resetPassModal = false">取 消</el-button>
        <el-button type="primary"
                   @click="confirmReset('resetPassForm')">重置</el-button>
      </span>
    </el-dialog>
  </el-row>
</template>

<script>
import fetch from '@/common/api'
import validate from '@/common/validate'
import AddUser from '@/views/system/user/AddUser'
import AssignRole from '@/views/system/user/AssignRole'
import Details from '@/views/system/user/Details'
import Pagination from '@/components/pagination/Pagination'
export default {
  components: { AddUser, AssignRole, Details, Pagination },
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.resetPassForm.password) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    return {
      searchForm: {
        username: '',
        fullname: '',
        mobile: '',
        status: ''
      },
      tiemArr: [],
      tableTitle: [
        {
          prop: 'username',
          name: '账号',
          fixed: 'left',
          width: 80
        },
        {
          prop: 'fullname',
          name: '姓名',
          width: 100
        },
        {
          prop: 'mobile',
          name: '联系方式',
          width: 100
        },
        {
          prop: 'user_role',
          name: '角色',
          width: 100
        },
        {
          prop: 'switchStaus',
          name: '状态',
          width: 80
        },
        {
          prop: 'creator',
          name: '创建人',
          width: 100
        }
      ],
      tableData: [],
      // 分页相关
      pagination: {
        total: 0,
        currentPage: 1,
        perPage: 10
      },
      // 添加用户相关
      showUserModal: false,
      userData: {
        type: 'add'
      },
      // 分配角色
      showRoleModal: false,
      roleData: {},
      // 详情
      showDetailModal: false,
      detailData: {},
      // 重置密码相关
      resetPassModal: false,
      resetPassForm: {
        password: '',
        checkPass: ''
      },
      resetRules: {
        password: [
          { required: true, message: '请输入密码' },
          { validator: validate.validPassword }
        ],
        checkPass: [{ required: true, message: '请再次确认密码' }, { validator: validatePass }]
      },
      // 记录重置密码的当前id
      currentId: ''
    }
  },
  computed: {
    getOnOff() {
      return function (status) {
        return Number(status) === 1 ? '禁用' : '启用'
      }
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    // 获取列表
    getList() {
      const { currentPage, perPage } = this.pagination
      fetch
        .getUserList({
          currentPage: currentPage,
          perPage: perPage,
          ...this.searchForm
        })
        .then((data) => {
          data.procData(
            data.res,
            (data) => {
              this.pagination.total = Number(data.total)
              this.tableData = data.list.map((item) => {
                item.switchStaus = item.status === '1' ? true : false
                return item
              })
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
    },
    // 搜索提交
    searchSubmit() {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.getList()
    },
    resetForm(formName) {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.$refs[formName].resetFields()
      this.getList()
    },
    // 新增
    handleAdd() {
      this.showUserModal = true
      this.userData = {
        type: 'add'
      }
    },
    // 分页
    handleSizeChange(val) {
      this.pagination.perPage = val
      this.pagination.currentPage = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getList()
    },
    // 详情
    handleDetail(data) {
      this.showDetailModal = true
      this.detailData = {
        id: data.id
      }
    },
    // 编辑
    handleEdit(data) {
      this.showUserModal = true
      this.userData = {
        type: 'edit',
        id: data.id
      }
    },
    // 重置密码
    handleVerify(data) {
      this.resetPassModal = true
      this.currentId = data.id
      this.resetPassForm = {
        password: '',
        checkPass: ''
      }
    },
    confirmReset(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          fetch.resetPassword({ id: this.currentId, ...this.resetPassForm }).then((data) => {
            data.procData(
              data.res,
              () => {
                this.resetPassModal = false
                this.$message.success('操作成功')
              },
              (err) => {
                this.$message.error(err)
              }
            )
          })
        }
      })
    },
    // 分配角色
    handleRole(data) {
      this.showRoleModal = true
      this.roleData = {
        type: 'edit',
        id: data.id
      }
    },
    // 关闭弹窗
    closeRoleModal(type) {
      if (type === 'refresh') {
        this.getList()
      }
      this.showRoleModal = false
    },
    // 关闭添加人员
    closeUserModal(params) {
      this.showUserModal = false
      if (params === 'refresh') {
        this.getList()
      }
    },
    // 关闭详情
    closeDetailModal() {
      this.showDetailModal = false
    },
    // 启用停用
    handleOnOff(status, data) {
      this.$confirm(`是否确定${this.getOnOff(data.status)}该用户?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          fetch.editUser({ id: data.id, status: status ? '1' : '0' }).then((data) => {
            data.procData(
              data.res,
              () => {
                this.$message.success('操作成功')
                this.getList()
              },
              (err) => {
                this.$message.error(err)
              }
            )
          })
        })
        .catch(() => {})
    },
    // 删除
    handleDelete(data) {
      this.$confirm('是否确定删除该条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          fetch.delUser({ id: data.id }).then((data) => {
            data.procData(
              data.res,
              () => {
                this.getList()
                this.$message.success('操作成功')
              },
              (err) => {
                this.$message.error(err)
              }
            )
          })
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped></style>
